package top.wcpe.allincore.dsl.compiler.semantic

/**
 * 元素上的动画引用 prop 名称。
 */
internal object AnimationRefs {
    val NAMES: Set<String> = setOf(
        // 通用引用
        "animation", "transition",
        // 旧触发器名（保留向后兼容）
        "onClickAnimation", "onChangeAnimation",
        // 新触发器 DSL：`on { trigger = "animName" }` 内允许的名字
        "click", "change", "enter", "exit", "hover", "leave",
        "press", "release", "idle", "reorder", "show", "hide",
    )
}
